import { checkIsStoryBookPath } from 'app/utils/check-is-story-book-path';

export const URI_PREFIX = checkIsStoryBookPath('tweets');
export const apiRoutes = {
  //tweet Details Page
  tweetDetails: `${URI_PREFIX}/tweet/show`,
  tweetRepliesSentiment: `${URI_PREFIX}/tweet/replies/sentiment-analysis/count`,
  tweetQuotesSentiment: `${URI_PREFIX}/tweet/quotes/sentiment-analysis/count`,
  tweetTopWords: `${URI_PREFIX}/tweet/frequent-words`,
  tweetFrequentHashtags: `${URI_PREFIX}/tweet/frequent-hashtags`,
  tweetHashTags: `${URI_PREFIX}/tweet/hashtags`,

  tweetReplies: `${URI_PREFIX}/tweet/replies`,
  tweetQuotes: `${URI_PREFIX}/tweet/quotes`,
  changeTweetQuotes: `${URI_PREFIX}/tweet/sentiment-analysis/quote/change-category`,
  tweetReplayConversation: `${URI_PREFIX}/tweet/reply/conversations`,
  mostFrequentWords: `${URI_PREFIX}/tweet/sentiment-analysis/frequent-words`,
  mostFrequentHashtags: `${URI_PREFIX}/tweet/sentiment-analysis/frequent-hashtags`,
  showTweetSentiment: `${URI_PREFIX}/tweet/sentiment-analysis/data/show`,
  updateTweetSentiment: `${URI_PREFIX}/tweet/sentiment-analysis/data/update`,
  tweetHashtagsAutocomplete: `${URI_PREFIX}/tweet/hashtags`,
  tweetSetsAutocomplete: `${URI_PREFIX}/sets`,
  tweetSentimentAnalysisAdd: `${URI_PREFIX}/tweet/sentiment-analysis/words/add`,
  changeTweetReplies: `${URI_PREFIX}/tweet/sentiment-analysis/reply/change-category`,
  //table
  allTweets: `${URI_PREFIX}/all`,
  allTweetsAutocomplete: `${URI_PREFIX}`,
  hashtagsAutocomplete: `${URI_PREFIX}/tweet/hashtags`,
  hashtagsTweetsAutocomplete: `${URI_PREFIX}/hashtags`,
  tweetIdsAutocomplete: `${URI_PREFIX}/remote-ids`,
  influencersAutocomplete: `${URI_PREFIX}/influencers`,
  incompleteTweets: `${URI_PREFIX}/incomplete`,
  deleteTweet: `${URI_PREFIX}/delete`,
  regrabTweet: `${URI_PREFIX}/regrab`,
  regrabTweetReplies: `${URI_PREFIX}/tweet/replies/regrab`,
  regrabTweetRepliesConversations: `${URI_PREFIX}/tweet/reply/conversations/regrab`,
  tweetInCompleteIdsAutocomplete: `${URI_PREFIX}/incomplete/remote-ids`,
  tweetTypes: `${URI_PREFIX}/types`,
  //dashboard
  tweetsCount: `${URI_PREFIX}/count`,
  tweetsHashtagsCount: `${URI_PREFIX}/hashtags/count`,
  tweetsAnalyzedHashtagsCount: `${URI_PREFIX}/hashtags/analyzed/count`,
  tweetsUnAnalyzedHashtagsCount: `${URI_PREFIX}/hashtags/un-analyzed/count`,
  tweetsInfluencersCount: `${URI_PREFIX}/influencers/count`,
  tweetsAnalyzedInfluencersCount: `${URI_PREFIX}/influencers/analyzed/count`,
  tweetsUnAnalyzedInfluencersCount: `${URI_PREFIX}/influencers/un-analyzed/count`,
  tweetsEntitiesCount: `${URI_PREFIX}/entities/count`,
  tweetsAnalyzedEntitiesCount: `${URI_PREFIX}/entities/analyzed/count`,
  tweetsTopUsedHashtags: `${URI_PREFIX}/top-hashtags`,

  //add new tweet
  addTweet: `${URI_PREFIX}/tweet/store`,
};
